/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopPodWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("TopPodWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TopPodWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TopPodWidgetConfiguration>): TopPodWidgetConfiguration {
        let obj = Object.assign(new TopPodWidgetConfiguration(), model);
        TopPodWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopPodWidgetConfiguration>): TopPodWidgetConfiguration {
        if (!model) return null;
        return TopPodWidgetConfiguration.newInstance(<TopPodWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopPodWidgetConfiguration) {
        if (!obj) return;

        models.TopPodWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopPodWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TopPodWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Platform this widget reports cost data for
     */
    platform: models.Platforms;

}
